import React, { useEffect, useState } from 'react';
import { MessageSquare } from 'lucide-react';
import PageHeader from '../components/PageHeader';
import { Badge } from '../components/ui/badge';
import { FeedbackAPI } from '../api';

const CAT_COLOR = {
  general: 'bg-slate-100 text-slate-700 border-slate-200',
  bug: 'bg-rose-500/10 text-rose-700 border-rose-500/30',
  feature: 'bg-sky-500/10 text-sky-700 border-sky-500/30',
  kudos: 'bg-emerald-500/10 text-emerald-700 border-emerald-500/30',
};

export default function FeedbackAdmin() {
  const [items, setItems] = useState([]);
  useEffect(() => { FeedbackAPI.list().then(setItems).catch(() => setItems([])); }, []);

  return (
    <div className="p-8 max-w-5xl mx-auto">
      <PageHeader title="Feedback" subtitle={`${items.length} submission${items.length !== 1 ? 's' : ''}`} />

      {items.length === 0 ? (
        <div className="text-center py-16 text-slate-500">
          <MessageSquare className="h-10 w-10 text-slate-300 mx-auto mb-2" />
          No feedback yet. Coaches will land here after they hit the 4-step loop.
        </div>
      ) : (
        <div className="space-y-3">
          {items.map(f => (
            <div key={f.id} className="bg-white border border-slate-200 rounded-xl p-5">
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <div className="font-semibold text-slate-900">{f.userName}</div>
                  <span className="text-xs text-slate-500">{f.userEmail}</span>
                </div>
                <div className="flex items-center gap-2">
                  <Badge className={CAT_COLOR[f.category] || CAT_COLOR.general}>{f.category}</Badge>
                  <span className="text-xs text-slate-500">{new Date(f.createdAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' })}</span>
                </div>
              </div>
              <p className="text-sm text-slate-700 leading-relaxed whitespace-pre-wrap">{f.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
